import React, { Component, PropTypes } from 'react';
import YouTube from 'components/youTube';

export default class FunVideoOverlay extends Component {

  static propTypes = {
    videoNumber: PropTypes.number.isRequired
  }

  static contextTypes = {
    program: PropTypes.object.isRequired,
    setMode: PropTypes.func.isRequired,
    setVideoState: PropTypes.func.isRequired,
    regionData: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  }

  click (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  close (evt) {
    const { setMode, setVideoState } = this.context;
    setMode('extras').then(() => {
      setVideoState({
        playing: false,
        started: false,
        finished: false
      });
    });
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  render () {
    const { videoNumber } = this.props;
    const { program: { funMd }, regionData, i18n: _ } = this.context;
    const funMd_i18n = _(funMd);
    const funItemNames = funMd_i18n.getSectionNames();
    const funItemName = funItemNames[videoNumber - 1];
    const youTubeId = funMd_i18n.getSectionMetadata(funItemName, 'YouTube', regionData);
    const lowRes = funMd_i18n.getSectionMetadata(funItemName, 'LowRes', regionData);
    const booleanLowRes = lowRes === 'true';

    return (
      <div
          className="fun-video"
          onClick={::this.click}>

        <button
            className="pull-right btn-link go-back"
            onClick={::this.close}>
          <i className="glyphicon glyphicon-remove"></i>
        </button>

        <YouTube youTubeId={youTubeId} lowRes={booleanLowRes} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/fun/funVideoOverlay.jsx